// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_53-7";
export var adjustableWidthBorderHeld = "_53-8";
export var arrow = "_53-3";
export var arrowButton = "_53-4";
export var headerCell = "_53-0";
export var help = "_53-2";
export var icon = "_53-1";
export var iconWrapper = "_53-6";
export var noBorder = "_53-b";
export var nonAdjustableWidthBorder = "_53-9";
export var nonAdjustableWidthBorderHeld = "_53-a";
export var textButton = "_53-5";